import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"search\">\r\n<title>search</title>\r\n<path d=\"M13.333 26.667c-7.467 0-13.333-5.867-13.333-13.333s5.867-13.333 13.333-13.333 13.333 5.867 13.333 13.333-5.867 13.333-13.333 13.333zM13.333 4c-5.067 0-9.333 4.267-9.333 9.333s4.267 9.333 9.333 9.333 9.333-4.267 9.333-9.333-4.267-9.333-9.333-9.333z\" />\r\n<path d=\"M18.821 21.912l2.828-2.829 10.184 10.181-2.828 2.829-10.184-10.181z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol